import { Card, CardContent, CardHeader } from "@/components/ui/card";

import { ReactElement } from "react";
import { cn } from "@/lib/utils";

type CardProps = React.ComponentProps<typeof Card> & {
  cardHeader?: ReactElement<typeof CardHeader>;
  children: React.ReactNode;
};

export function CardWrapper({
  cardHeader,
  children,
  className,
  ...props
}: CardProps) {
  return (
    <Card className={cn("w-[450px] py-8", className)} {...props}>
      {cardHeader}
      <CardContent>{children}</CardContent>
    </Card>
  );
}
